var $header = $('.js-gnavi');
// Nav Fixed
// $(window).scroll(function() {
  // if ($(window).scrollTop() > 680) {
  //     $header.addClass('fixed');
  // } else {
  //     $header.removeClass('fixed');
  // }
  // $header.addClass('fixed');
// });
// Nav Toggle Button
$('.gnavi-button-icon-open').click(function(){
  $header.toggleClass('is-open');
  document.body.classList.add('overflow-hidden');
});

// Nav Toggle Button
$('.gnavi-button-icon-close').click(function(){
  $header.removeClass('is-open');
  document.body.classList.remove('overflow-hidden');
});

// Scroll Top
const PageTopBtn = document.getElementById('js-scroll-top');
PageTopBtn.addEventListener('click', () =>{
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});

$(function() {
  var topBtn = $('#js-scroll-top');
  topBtn.hide();
  //スクロールが100に達したらボタン表示
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  //スクロールしてトップ
    topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
    });
});

// Anchor Link
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = 60;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}

const accordion = document.querySelectorAll(".js-accordion");

function toggle() {
  const content = this.nextElementSibling;
  this.classList.toggle("is-active");
  content.classList.toggle("is-open");
}

for (let i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", toggle);
}


// map
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.map').each(function(){
        var map = initMap( $(this) );
    });
});


$(document).ready(function(){
  // wp内で指定する
  // var path = '/wp-content/themes/suwareligion/';
  var domain = document.domain;

  //ローカルではパスを変える
  if(domain.indexOf('localhost') !== -1) path = '../img/';

  $('.news-list').slick({
    dots: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    prevArrow: '<img src="' + path +'/img/arrow_prev.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="' + path +'/img/arrow_next.png" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '300px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1279,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '200px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.temple-research-list').slick({
    dots: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    prevArrow: '<img src="' + path +'arrow_prev.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="' + path +'arrow_next.png" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          arrows: true,
          centerMode: true,
          // centerPadding: '300px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1279,
        settings: {
          arrows: true,
          centerMode: true,
          // centerPadding: '200px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          // centerPadding: '10px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          // centerPadding: '10px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          // centerPadding: '10px',
          slidesToShow: 1
        }
      }
    ]
  });
});

